<div class="filter-group" data-group-visibility-id="showMyWeaponFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showMyWeaponFilters" (click)="filter.groupVisibility.showMyWeaponFilters = !filter.groupVisibility.showMyWeaponFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Weapons" [activeRules]="activeSpecialRules.weaponExceptions">
          Select the weapons you are looking for for your character(s), optionally set minimal conditions, and configure which Variants (like Crafting Bases{{ poe2 ? ' or Tiered Unidentified versions' : '' }}) you're interested in and how they should be highlighted using the <span class="icon icon-equalizer"></span> button.

          <br /><br /><app-content cid="gear-tiers" contentType="tip" [conditions]="{poe2: poe2, extraInfo: true}" style="display: inline-block;"></app-content>

          @if (poe2) {
            <br/><br/>Note that all Sceptres, Staves, Wands and Quivers have different implicits, and thus their division into Gear Tiers is more arbitrary and opinionated. Be sure to review these in the <a href="/tier-list/gear">Gear Tier List</a> tab, or select 'All' to show all types.
          }
          <br/><br/>You will find Shields in the Armour section below, so you can specify the desired defence type.
          <br/><br/>Rules with a <span class="equipment-filter-from-preset-example">gold line</span> to the left were automatically generated from your Class or Progress Preset, and might get changed along with presets.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showMyWeaponFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showMyWeaponFilters">

      @for (weapon of filter.weaponFilters; track $index) {
        <app-weapon-filter
          [weapon]="weapon"
          [index]="$index"
          (remove)="removeWeaponType($event)">
        </app-weapon-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addWeaponType()">
          Add Weapon Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
